import React, { useMemo, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames/bind';
import qs from 'qs';
import { useAppDispatch } from 'app/hooks';
import http, { fetcher } from 'app/http';
import { setContent } from 'features/content/reducer';
import PrefixSelect, {
  ICountryPrefix,
} from 'components/PhoneInput/PrefixSelect/PrefixSelect';
import Icon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';
import { getErrorObject, REGEXP_EMAIL } from 'common/helpers/valdiation';
import { Controller, useForm } from 'react-hook-form';
import styles from './RegistrationVerifyEmailSmsPageData.module.scss';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';
import { formProgression, formError } from 'common/helpers/Gtm';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}
const getDefaultPrefix = (prefixes: ICountryPrefix[]) =>
  (prefixes || []).find((prefix) => prefix.Selected);

const RegistrationVerifyEmailSmsPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const defaultPrefix = useMemo(
    () => getDefaultPrefix(Model?.CountryPrefixDropDown),
    [Model?.CountryPrefixDropDown],
  );
  const [showMobileVerification, setShowMobileVerification] = useState<boolean>(
    Model?.ShowMobileVerification,
  );
  const [isMobilePhoneSubmitted, setIsMobilePhoneSubmitted] =
    useState<boolean>(false);
  const [eventTracked, setEventTracked] = useState<boolean>(false);

  const showEmailVerification = () => {
    reset({
      FormModel: {
        DebtReference: Model?.FormModel?.DebtReference,
        ProfileId: Model?.FormModel?.ProfileId,
        EmailAddress: Model?.FormModel?.EmailAddress,
        MobileNumber: Model?.FormModel?.MobileNumber,
        showUserAlreadyExists: Model?.FormModel?.showUserAlreadyExists,
        CountryPrefixCode: defaultPrefix?.Value,
      },
    });
    setShowMobileVerification(false);
  };
  const showMobileVerificationForm = () => {
    reset({
      FormModel: {
        DebtReference: Model?.FormModel?.DebtReference,
        ProfileId: Model?.FormModel?.ProfileId,
        EmailAddress: Model?.FormModel?.EmailAddress,
        MobileNumber: Model?.FormModel?.MobileNumber,
        showUserAlreadyExists: Model?.FormModel?.showUserAlreadyExists,
        CountryPrefixCode: defaultPrefix?.Value,
      },
    });
    setShowMobileVerification(true);
  };
  const {
    control,
    register,
    reset,
    formState: { isValid, errors },
    handleSubmit,
    getFieldState,
  } = useForm({
    defaultValues: {
      FormModel: {
        DebtReference: Model?.FormModel?.DebtReference,
        ProfileId: Model?.FormModel?.ProfileId,
        EmailAddress: Model?.FormModel?.EmailAddress,
        MobileNumber: Model?.FormModel?.MobileNumber,
        showUserAlreadyExists: Model?.FormModel?.showUserAlreadyExists,
        CountryPrefixCode: defaultPrefix?.Value,
      },
    },
    mode: 'all',
  });

  const mobileNumberState = getFieldState('FormModel.MobileNumber');
  const emailAddressState = getFieldState('FormModel.EmailAddress');
  let history = useHistory();

  useEffect(() => {
    if (eventTracked == false) {
      var tagManagerArgs: any;
      tagManagerArgs = {
        dataLayer: {
          event: 'checkout_step',
          checkout_name: 'Registration',
          checkout_step_number: '2'
        }
      }
      TagManager.dataLayer(tagManagerArgs);
      setEventTracked(true);
    }
  }, [eventTracked]);

  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);

    return link.pathname + link.search;
  };
  const postMobileNumberUrl = getPathnameFromUrl(Model?.PostPhoneNumberLink);
  const postEmailAddressUrl = getPathnameFromUrl(Model?.PostEmailAddressLink);

  const handleMobileNumberForm = handleSubmit((data) => {
    onMobileNumberSubmit(data);
  });

  const handleEmailAddressForm = handleSubmit((data) => {
    onEmailSubmit(data);
  });

  const onEmailSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      const postEmailResponse = await fetcher.post(
        postEmailAddressUrl,
        qs.stringify(data),
      );

      if (postEmailResponse) {
        if (postEmailResponse?.data?.RedirectUrl) {
          const redirectPath = getPathnameFromUrl(
            postEmailResponse?.data?.RedirectUrl,
          );
          const responseFromRedirect = await fetcher.get(redirectPath);
          if (!responseFromRedirect?.data?.RedirectUrl) {
            dispatch(setContent({ [redirectPath]: responseFromRedirect.data }));
            history.push(redirectPath, { noRefresh: true });
            return;
          } else {
            const path = getPathnameFromUrl(
              responseFromRedirect?.data?.RedirectUrl,
            );
            history.push(path, { noRefresh: false });
            return;
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const onMobileNumberSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      const postMobileNumberResponse = await fetcher.post(
        postMobileNumberUrl,
        qs.stringify(data),
      );
      if (postMobileNumberResponse) {
        setIsMobilePhoneSubmitted(true);
        var nextPagePath = '';
        if (postMobileNumberResponse?.data?.RedirectUrl) {
          const redirectPath = getPathnameFromUrl(
            postMobileNumberResponse?.data?.RedirectUrl,
          );
          const responseFromRedirect = await fetcher.get(redirectPath);
          if (!responseFromRedirect?.data?.RedirectUrl) {
            dispatch(setContent({ [redirectPath]: responseFromRedirect.data }));
            history.push(redirectPath, { noRefresh: true });
            return;
          } else {
            const path = getPathnameFromUrl(
              responseFromRedirect?.data?.RedirectUrl,
            );
            history.push(path, { noRefresh: false });
            return;
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };
  const [showMobileNumberError, setShowMobileNumberError] = useState<Boolean>(
    Model?.ShowMobileNumberError,
  );
  const handleMobileChange = (e: any) => {
    if (showMobileNumberError == true && isMobilePhoneSubmitted == true) {
      setShowMobileNumberError(false);
    }
  };
  useEffect(() => {
    setShowMobileNumberError(Model?.ShowMobileNumberError);
    setIsMobilePhoneSubmitted(true);
  }, [Model]);

  const isDisabledSubmit = useMemo(() => {
    if (isValid && !isSubmitting) {
      return false;
    }
    return true;
  }, [isValid, isSubmitting]);

  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length > 0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);
  
    useEffect(() => {
      if(emailAddressState.error)
      { 
          formError('Registration','Email Address','error_Incorrect_Email_Address')           
      }
    }, [emailAddressState.error]);
    
  return (
    <>
      <div className="u-marginBxxsm u-marginTxxsm">
        <div className="step-wizard">
          <div className="step-wizard-container">
            <a onClick={() => history.go(-1)}>
              <img src="/assets/images/icons/Chevron.svg" />
            </a>
            <p className="u-textCenter">
              {PageData?.StepText} <span className="u-textWeightBold">2</span>{' '}
              {PageData?.OfText} <span className="u-textWeightBold">4</span>
            </p>
            <a
              id="cancelregistration"
              data-modal-url={Model?.CancelRegistrationPageUrl}
            >
              <img
                src="/assets/images/icons/CloseIcon.svg"
                className="u-hidden"
              />
            </a>
          </div>
        </div>
      </div>
      <section className="Section">
        <div className="Page-container PageContainer--transparent">
          {showMobileVerification && (
            <div
              id="mobileVerification"
              className="auth0-container u-alignCenter"
            >
              <div className="form-heading">
                {PageData?.MobileVerificationRequiredLabel}
              </div>

              <form onSubmit={handleMobileNumberForm}>
                <div className="u-marginBxmb u-textLeft">
                  <p className="form-text textleftmobile">
                    {PageData?.MobileVerificationRequiredNoteText}
                  </p>
                </div>
                <div className={'form-group'}>
                  <label>{PageData?.MobileNumberLabel}</label>

                  <div
                    className={classNames(
                      styles.mobileNumberWrapper,
                      showMobileNumberError && styles.hasError,
                    )}
                  >
                    <Controller
                      control={control}
                      name={'FormModel.CountryPrefixCode'}
                      render={({ field: { onChange, name, value } }) => (
                        <PrefixSelect
                          name={name}
                          value={value || defaultPrefix?.Value}
                          prefixes={Model?.CountryPrefixDropDown}
                          className={styles.mobileNumberSelect}
                          onChange={onChange}
                        />
                      )}
                    />

                    <input
                      {...register('FormModel.MobileNumber', {
                        required: true,
                        minLength: {
                          value: Model?.MobilePhoneNumberMinLength,
                          message: PageData?.IncorrectMobileNumberLabel,
                        },
                        maxLength: {
                          value: Model?.MobilePhoneNumberMaxLength,
                          message: PageData?.IncorrectMobileNumberLabel,
                        },
                        onChange: handleMobileChange,
                      })}
                      type="number"
                      className={styles.mobileNumberInput}
                      onBlur={(e)=>formProgression(e,'Registration','MobileNumber')}
                    />
                    {mobileNumberState.isDirty &&
                      !mobileNumberState.invalid &&
                      !showMobileNumberError && (
                        <Icon
                          type={SvgIcons.SUCCESS}
                          width={24}
                          className={styles.stateIcon}
                        />
                      )}
                    {/* {mobileNumberState.error && (
                                            <Icon
                                                type={SvgIcons.ERROR}
                                                width={16}
                                                className={styles.stateIcon}
                                            />
                                        )} */}
                  </div>
                </div>

                {showMobileNumberError && (
                  <span id="phoneNumberValidationMessage" className="error">
                    {PageData?.IncorrectMobileNumberLabel}
                  </span>
                )}

                <div className={styles.ctaWrapper}>
                  <button
                    type="submit"
                    className={classNames(
                      styles.submitBtn,
                      !isDisabledSubmit && styles.active,
                    )}
                    disabled={isDisabledSubmit}
                  >
                    {PageData?.SendCodeButtonLabel}
                  </button>
                </div>
                <div className="u-textCenter form-text">
                  <a
                    onClick={showEmailVerification}
                    id="emailVerificationLink"
                    className="form-text-bold u-textdecoration"
                  >
                    {PageData?.EmailVerificationLinkText}
                  </a>
                </div>
              </form>
            </div>
          )}

          {!showMobileVerification && (
            <div
              id="emailVerification"
              className="auth0-container u-alignCenter"
            >
              <div className="form-heading">
                {PageData?.EmailVerificationRequiredLabel}
              </div>
              <form onSubmit={handleEmailAddressForm}>
                <div className="u-textLeft">
                  <p className="form-text textleftmobile">
                    {PageData?.EmailVerificationRequiredNoteText}
                  </p>
                </div>

                <div
                  className={classNames(
                    'form-group',
                    emailAddressState.error && 'error-message',
                    emailAddressState.isDirty &&
                    !emailAddressState.invalid &&
                    'valid',
                  )}
                >
                  <label>{PageData?.EmailAddressLabel}</label>

                  <div className={styles.typeContent}>
                    <input
                      {...register('FormModel.EmailAddress', {
                        required: true,
                        pattern: {
                          value: REGEXP_EMAIL,
                          message: PageData?.EmailErrorMessage,
                        },
                      })}
                      placeholder={PageData?.EmailPlaceHolderText}
                      name="FormModel.EmailAddress"
                      className="form-class"
                      aria-invalid="true"
                      type="email"
                      onBlur={(e)=>formProgression(e,'Registration','EmailAddress')}
                    />
                    <div className="invertable-mark"></div>

                    {Model.FormModel.showUserAlreadyExists && (
                      <span id="userExistsError" className="error">
                        {PageData?.UserAlreadyExistsLabel}
                      </span>
                    )}
                    {emailAddressState.error && (
                      <span id="ivalidEmailErrorMessage" className="error">
                        {PageData?.IncorrectEmailAddressLabel}
                      </span>
                    )}
                  </div>
                </div>
                <div className={styles.ctaWrapper}>
                  <button
                    type="submit"
                    className={classNames(
                      styles.submitBtn,
                      !isDisabledSubmit && styles.active,
                    )}
                    disabled={isDisabledSubmit}
                  >
                    {PageData?.SendCodeButtonLabel}
                  </button>
                </div>
                <div className="u-textCenter form-text">
                  <a
                    onClick={showMobileVerificationForm}
                    className="form-text-bold u-textdecoration"
                  >
                    {PageData?.MobileNumberVerificationLinkText}
                  </a>
                </div>
              </form>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default RegistrationVerifyEmailSmsPageData;
